var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7005_3177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.5H13.5V7.50003C13.5001 7.43435 13.4872 7.3693 13.4621 7.3086C13.437 7.2479 13.4002 7.19275 13.3538 7.14628L8.35375 2.14628C8.30731 2.09979 8.25217 2.06291 8.19147 2.03775C8.13077 2.01259 8.06571 1.99963 8 1.99963C7.93429 1.99963 7.86923 2.01259 7.80853 2.03775C7.74783 2.06291 7.69269 2.09979 7.64625 2.14628L2.64625 7.14628C2.59983 7.19275 2.56303 7.2479 2.53793 7.3086C2.51284 7.3693 2.49995 7.43435 2.5 7.50003V13.5Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7005_3177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.cd00cb95dbb1632bbb03586db24ade4d.svg";
export { ForwardRef as ReactComponent };